import { render, staticRenderFns } from "./ChildDeviceTableColumnsModal.vue?vue&type=template&id=0c7f511a"
import script from "./ChildDeviceTableColumnsModal.vue?vue&type=script&lang=ts"
export * from "./ChildDeviceTableColumnsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports